export function minutesToHours(minutes) {
  const num = Number(minutes);
  if (!Number.isFinite(num) || num <= 0) return 0;
  return Math.round((num / 60) * 100) / 100;
}

export function hoursToMinutes(hours) {
  const num = Number(hours);
  if (!Number.isFinite(num) || num === 0) return 0;
  return Math.round(num * 60);
}

/**
 * Whole hours + leftover minutes / 60.
 * 90 → "١٫٥", 12 → "٠٫٢", 60 → "١"
 */
export function formatHoursAndMinutes(totalMinutes) {
  if (totalMinutes == null || totalMinutes === "") return "—";
  const raw = Number(totalMinutes);
  if (!Number.isFinite(raw)) return "—";
  const hours = Math.floor(raw / 60);
  const leftoverHours = (raw % 60) / 60;
  const value = Math.round((hours + leftoverHours) * 100) / 100;
  return value.toLocaleString("ar-EG", {
    maximumFractionDigits: 2,
  });
}

export function lateHoursFromRow(row) {
  if (row?.lateHours != null && Number.isFinite(Number(row.lateHours))) {
    return Number(row.lateHours);
  }
  return minutesToHours(row?.lateMinutes);
}

export function lateMinutesFromRow(row) {
  if (row?.lateMinutes != null && Number.isFinite(Number(row.lateMinutes))) {
    return Number(row.lateMinutes);
  }
  return hoursToMinutes(row?.lateHours);
}
